import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import ActivitiesPropertyGroup from '../../../components/PropertyGroup/ActivitiesPropertyGroup';
import ListingSection from '../ListingSection';
import ListingSectionItem from '../ListingSectionItem';

/**
 * This component shows the activities section of a listing.
 * @param {object} props
 * @param {object} props.options - Configuration options for the activities property group.
 * @param {Array<string>} props.activities - Array of selected activities.
 * @returns {React.JSX.Element|null}
 */

const SectionActivitiesMaybeComponent = ({ options, activities = [] }) => {
  // Directly extract and check the length of selectedOptions for nullish publicData or empty activities array.
  const selectedOptions = activities ?? [];
  if (selectedOptions.length === 0) {
    return null;
  }

  return (
    <ListingSection>
      <ListingSectionItem
        params={{
          sx: { justifyContent: { xs: 'center', sm: 'flex-start' } },
        }}
      >
        <Typography
          component="h3"
          mb={2}
          sx={{ textAlign: { xs: 'center', sm: 'left' } }}
          variant="h4"
        >
          <FormattedMessage id="ListingPage.activitiesTitle" />
        </Typography>
      </ListingSectionItem>
      <ListingSectionItem
        params={{
          sx: { textAlign: { xs: 'center', sm: 'left' } },
        }}
      >
        <ActivitiesPropertyGroup
          options={options}
          selectedOptions={selectedOptions}
          showNotSelectedItems={false}
          twoColumns={true}
        />
      </ListingSectionItem>
    </ListingSection>
  );
};

SectionActivitiesMaybeComponent.displayName = 'SectionActivitiesMaybe';

const SectionActivitiesMaybe = memo(SectionActivitiesMaybeComponent);

export default SectionActivitiesMaybe;
